import { useMutation, UseMutationResult } from "@tanstack/react-query";
import {
  WiseOwlApiResponse,
  WiseOwlIngress,
  WiseOwlGetHomeResponseData,
} from "@twiliointernal/e2-commons-shared-definitions";

import { WiseOwlApi } from "@twiliointernal/e2-commons-shared-api";

const useGetHcaInsights = ({
  ingress,
}: {
  ingress: WiseOwlIngress;
}): UseMutationResult<WiseOwlApiResponse<WiseOwlGetHomeResponseData>> => {
  return useMutation({
    mutationFn: async () => {
      const wiseOwlApi = new WiseOwlApi(ingress);
      return wiseOwlApi.getHcaInsights({ headers: {} }) as Promise<
        WiseOwlApiResponse<WiseOwlGetHomeResponseData>
      >;
    },
  });
};

export default useGetHcaInsights;
